import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGifts } from '../../redux/actions/pack';
import GeneralNotifModal from '../GeneralModal/generalNotifModal';
import { sendGift } from '../../redux/actions/liveShow';
import { Loading, TopupGuideline } from '..';
import diamonds from '../../assets/diamonds.svg';
import backIcn from '../../assets/back-circle-arrow.svg';
import nextIcn from '../../assets/next-circle-arrow.svg';
import styles from './SendGiftMenu.module.css';
import { getAccountInfo } from '../../redux/actions/auth';

const SendGiftMenu = ({ clipsSection, videoId, showId, giftType }) => {
  const dispatch = useDispatch();
  const { profileInfo } = useSelector((state) => state.publicProfile);
  const dataGifts = useSelector((state) => state.pack.giftOption);
  // const [selectedGift, setSelectedGift] = useState();
  const [giftSendModalContainer, setShowgiftSendModalContainer] =
    useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [giftPacks, setGiftPacks] = useState([]);
  const [giftIndex, setGiftIndex] = useState(-1);
  const [pack, setPack] = useState(null);
  const [giftModalPosition, setGiftModalPosition] = useState([0, 0]);
  const [packAmount, setPackAmount] = useState(null);
  const [giftIcon, setGiftIcon] = useState('');
  const [sendingGift, setSendingGift] = useState(false);
  const [notEnough, setNotEnough] = useState(false);
  const [showSendStatusModal, setShowSendStatusModal] = useState();
  const [showTopUpGuideline, setShowTopUpGuideline] = useState(false);
  const { account } = useSelector((state) => state?.auth?.user);
  const [userDiamonds, setUserDiamonds] = useState(account?.diamonds);

  const getDiamonds = useCallback(async () => {
    await dispatch(getAccountInfo({ dispatchState: false })).then((res) => {
      setUserDiamonds(res?.account?.diamonds || account?.diamonds);
    });
  }, [dispatch, setUserDiamonds, account]);

  useEffect(() => {
    getDiamonds();
    dispatch(getGifts());
  }, [dispatch, getDiamonds]);

  const printMousePos = useCallback(
    (event) => {
      if (
        event.target.name === 'giftImage' ||
        event.target.classList.value.includes('listGifts')
      ) {
        const windowSize = window.outerWidth - 540;
        const val = clipsSection ? 400 : 200;

        setGiftModalPosition([
          Math.min(Math.max(event.clientX - val, 0), Math.max(windowSize, 0)), //making sure it won't go over the window size
          event.clientY,
        ]);
      }
    },
    [clipsSection]
  );

  useEffect(() => {
    document.addEventListener('click', printMousePos, true);
    return () => document.removeEventListener('click', printMousePos);
  }, [printMousePos]);

  const handleConfirmSendDiamond = () => {
    if (userDiamonds && userDiamonds > parseInt(packAmount)) {
      setShowConfirmDialog(true);
    } else {
      setShowTopUpGuideline(true);
      setNotEnough(true);
    }
  };

  const slide = (direction) => {
    var container = document.getElementById('gifts');
    let scrollCompleted = 0;
    var slideVar = setInterval(function () {
      if (direction === 'left') {
        container.scrollLeft -= 10;
      } else {
        container.scrollLeft += 10;
      }
      scrollCompleted += 10;
      if (scrollCompleted >= 100) {
        window.clearInterval(slideVar);
      }
    }, 50);
  };

  const handleSendGift = async () => {
    setSendingGift(true);

    try {
      await dispatch(
        sendGift({
          packId: pack,
          receiverId: profileInfo?.profile.accountId,
          showId: showId,
          videoId: videoId,
          giftType,
        })
      );

      setShowSendStatusModal({
        status: 'success',
        title: 'Send Diamonds Successful',
        message: `You successfully sent ${parseInt(packAmount)} ${
          parseInt(packAmount) === 1 ? 'Diamond ' : 'Diamonds '
        } to ${profileInfo?.profile.name}.`,
      });
      setPack(null);
      setPackAmount(null);
      setShowgiftSendModalContainer(false);
    } catch (err) {
      setShowSendStatusModal({
        status: 'failed',
        title: 'Send Diamonds Failed',
        message: `Failed to send Diamonds to ${profileInfo?.profile.name}. Please try again later.`,
      });
    } finally {
      setSendingGift(false);
      setShowConfirmDialog(false);
    }
  };

  const handleCloseSendStatusModal = () => {
    if (showSendStatusModal && showSendStatusModal.status === 'success') {
      getDiamonds();
    }

    setShowSendStatusModal();
  };
  const gifts = giftPacks.sort((a, b) => a.amount < b.amount);

  const GiftModal = () => {
    return (
      <div
        id='giftModal'
        className={styles.giftSendModalContainer}
        style={{
          position: 'absolute',
          left: giftModalPosition[0],
          zIndex: '10',
        }}
      >
        <div className={styles.row}>
          <div>
            <img src={giftIcon?.url} alt='gift' width='30' height='25' />{' '}
            <span></span>
          </div>
          <div
            style={{
              marginLeft: 'auto',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img src={diamonds} alt='diamond' width='30' height='20' />
            {'  '}
            <span>{parseInt(packAmount)}</span>
          </div>
        </div>
        <div className={styles.row}>
          {gifts.map((packData, index) => {
            let classValue = `${styles.giftAmounts} ${
              packData.id === pack
                ? giftSendModalContainer && styles.active
                : ''
            }`;
            return (
              <span
                onClick={() => {
                  setPack(packData.id);
                  setPackAmount(packData.price);
                }}
                className={classValue}
                key={index}
                value={packData.id}
              >
                {packData.amount}
              </span>
            );
          })}
          <span
            onClick={handleConfirmSendDiamond}
            className={styles.sendGiftButton}
          >
            Send
          </span>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={styles.sendGiftContainer}>
        {giftSendModalContainer && <GiftModal />}
        <div className={styles.balanceContainer}>
          <span className={styles.balance}>Your Balance : </span>
          <div className={styles.balanceContent}>
            <img
              className={styles.diamond}
              src={diamonds}
              alt='diamond'
              width='30'
              height='20'
            />
            <span className={styles.balance}> {userDiamonds} </span>
            <span
              className={styles.topup}
              onClick={() => setShowTopUpGuideline(true)}
            >
              Top up
            </span>
          </div>
        </div>
        <div className={styles.giftList}>
          <img src={backIcn} alt='prev' onClick={() => slide('left')} />
          <div id='gifts' className={styles.gifts}>
            {dataGifts.map((item, index) => {
              const icon = item.icons.find((i) => i.type === 'static');
              return (
                <span
                  id={
                    giftIndex === index &&
                    giftSendModalContainer &&
                    styles.giftActive &&
                    'gifts'
                  }
                  key={index}
                  className={`${styles.listGifts} ${
                    giftIndex === index &&
                    giftSendModalContainer &&
                    styles.giftActive
                  }`}
                  onClick={() => {
                    setPack(item.packs[0].id);
                    setGiftPacks(item.packs);
                    setGiftIndex(index);
                    setGiftIcon({ ...icon });
                    setPackAmount(item.packs[0].price);
                    setShowgiftSendModalContainer(
                      item.packs[0].id === pack ? !giftSendModalContainer : true
                    );
                  }}
                >
                  <img
                    name='giftImage'
                    src={icon.url}
                    alt='diamond'
                    width='30'
                    height='25'
                  />
                </span>
              );
            })}
          </div>
          <img src={nextIcn} alt='next' onClick={() => slide('right')} />
        </div>
      </div>
      <GeneralNotifModal
        open={showConfirmDialog}
        contentClass={styles.confirmModal}
      >
        {sendingGift ? (
          <>
            <Loading />
            <p>Sending Gift</p>
          </>
        ) : (
          <>
            <h3>Send Diamonds?</h3>
            <p>
              Are you sure to send {parseInt(packAmount)}{' '}
              {parseInt(packAmount) === 1 ? 'Diamond ' : 'Diamonds '}
              to {profileInfo?.profile.name}?
            </p>
            <div
              className={`${styles.actionButton} ${styles.confirmButton}`}
              onClick={handleSendGift}
            >
              Yes, Sure
            </div>
            <div
              className={styles.actionButton}
              onClick={() => {
                setShowConfirmDialog(false);
              }}
            >
              Cancel
            </div>
          </>
        )}
      </GeneralNotifModal>

      {showSendStatusModal && (
        <GeneralNotifModal
          open={showSendStatusModal}
          contentClass={styles.confirmModal}
        >
          <h3>{showSendStatusModal.title}</h3>
          <p>{showSendStatusModal.message}</p>
          {showSendStatusModal.status === 'success' && (
            <div className={styles.successAnimation}>
              <div className={styles.circleAnimation}></div>
              <svg viewBox='0 0 100 100'>
                <path d='m 2 43 l 37 35 l 55 -60'></path>
              </svg>
            </div>
          )}
          <div
            className={`${styles.actionButton} ${styles.primaryButton}`}
            onClick={handleCloseSendStatusModal}
          >
            {showSendStatusModal.status === 'success' ? 'Done' : 'OK'}
          </div>
        </GeneralNotifModal>
      )}

      <TopupGuideline
        open={showTopUpGuideline}
        dismiss={() => {
          setShowTopUpGuideline(false);
          setNotEnough(false);
        }}
      >
        {notEnough && (
          <h3 className={styles.topUpHeader}>Not Enough Diamonds</h3>
        )}
      </TopupGuideline>
    </>
  );
};

export default SendGiftMenu;
